import React from "react";
import type { TypeButtonProps } from "./ButtonTypes";
import ButtonHybrid from "./ButtonHybrid";

/**
 * Button component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Button = React.forwardRef<HTMLButtonElement, TypeButtonProps>(
  (props, ref) => <ButtonHybrid {...props} ref={ref} />
);

Button.displayName = "Button";
export default Button;
